import React, { useState , useEffect} from 'react'
import { useParams } from 'react-router-dom'
import {
	Header,
} from '../../componentsRef'
import {Spinner} from '../../componentsRef/ui'
import {LogoutPopup} from '../LogoutPopup'
import TableauReport from 'tableau-react'
import {envVariables} from '../../utils/envVariables/envVariables'
import {getAccessToken} from '../../utils/authSession'

const buildTableauViewUrl = (viewPath) => {
	const baseUrl = envVariables.tableauServerBaseUrl?.replace(/\/$/, '')
	const site = envVariables.tableauSite

	if (!baseUrl || !site || !viewPath) return ''

	return `${baseUrl}/t/${site}/views/${viewPath}`
}

const DASHBOARD_VIEW_ALIASES = {
	evaluation: 'evaluacion',
	planning: 'planificacion',
	history: 'historial',
	margins: 'panelmargenes',
	penetration: 'panelpenetraciones',
	forecast: 'forecastprecios',
	prices: 'preciosporsala',
}

const getDashboardViewPath = (page) => {
	const normalizedPage = String(page || '').toLowerCase()
	const viewKey = DASHBOARD_VIEW_ALIASES[normalizedPage] || normalizedPage

	return envVariables.tableauViews[viewKey] || envVariables.tableauViews.default
}

const getChainName = (chain) => {
	if (typeof chain === 'string') return chain
	if (!chain || typeof chain !== 'object') return ''

	return chain.nombre || chain.name || chain.label || chain.value || ''
}

const getStoredUserData = () => {
	try {
		return JSON.parse(localStorage.getItem('user_data'))
	} catch (error) {
		console.warn('Invalid user_data in localStorage', error)
		return null
	}
}

const getMissingDashboardConfig = (viewPath) => {
	const requiredConfig = [
		['REACT_APP_TABLEAU_SERVER_BASE_URL', envVariables.tableauServerBaseUrl],
		['REACT_APP_TABLEAU_SITE', envVariables.tableauSite],
		['REACT_APP_TABLEAU_TRUST_URL', envVariables.tableauTrustUrl],
		['REACT_APP_TABLEAU_DASHBOARD_PROJECT', envVariables.tableauDashboardProject],
		['REACT_APP_TABLEAU_DASHBOARD_PAGE', envVariables.tableauDashboardPage],
		['REACT_APP_TABLEAU_VIEW_*', viewPath],
	]

	return requiredConfig.filter(([, value]) => !value).map(([key]) => key)
}

export const Dashboard = () => {
    const [tokenTableau, setTokenTableau] = useState()
	const [tableauError, setTableauError] = useState('')
	const { pagina } = useParams()
	const [LogoutState, setLogoutState] = useState(false)
	const viewPath = getDashboardViewPath(pagina)
	const url_ = buildTableauViewUrl(viewPath)
	const missingConfig = getMissingDashboardConfig(viewPath)
	let parameters_ = null;
	let nombresCadenas = [];
	const data = getStoredUserData();
	nombresCadenas = (data?.user_data?.cadenas || [])
		.map(getChainName)
		.filter(Boolean)
		.map((chainName) => String(chainName).toUpperCase())
			// const resultadoCadenas = "Cadena="+nombresCadenas.join(', ');
	parameters_ = {
				"Cadena_original" : nombresCadenas
			}
	/*
            parameters_ = {
			ID1: [dataProduct.code_product + '-' + data.cadena_details.name_customer],
		}
    */
	const fetchApi = async () => {
		if (missingConfig.length) {
			setTableauError(`Configuración de Tableau incompleta. Faltan: ${missingConfig.join(', ')}`)
			return
		}

		try {
			const response = await fetch(envVariables.tableauTrustUrl, {
				method: 'POST',
				body: JSON.stringify({
					token: getAccessToken() + '-2chzRY3F3I9@',
					tabs_permission: envVariables.tableauTabsPermission,
					dtarget_site: envVariables.tableauSite,
					project: envVariables.tableauDashboardProject,
					page: envVariables.tableauDashboardPage,
				}),
			})

			console.log(response.status)
			const responseJSON = await response.json()
			setTokenTableau(responseJSON.token_server)
		} catch (error) {
			console.error(error)
			setTableauError('No fue posible cargar la configuración de Tableau.')
		}
	}

    useEffect(() => {
		fetchApi()
    }, [pagina])

	return (
		<div className='HomeNew'>
			{LogoutState && <LogoutPopup setLogoutState={setLogoutState} />}
            <Header setLogoutState={setLogoutState} />
			{tableauError ? (
				<div style={{padding: '24px', color: '#474747'}}>{tableauError}</div>
			) : !tokenTableau ? (
				<Spinner />
			) : (
				<TableauReport
					url={url_}
					token={tokenTableau}
					options={{
						width: "100%",
						height: "95vh",
					}}
					query="?:jsdebug=n"
					parameters={nombresCadenas.length > 0 ? parameters_ : null}
				/>
			)}
		</div>
	)
}
